export default "__VITE_ASSET__BbqcaanS__"